const initializeFunctionality = () => {
  const legalAddressInput = document.getElementById("business_information_legal_address");
  const mailingAddressInput = document.getElementById("business_information_mailing_address");
  const mailingAddressCheckbox = document.getElementById(
    "business_information_mailing_address_same_as_legal_address",
  );
  const dbaAddressInput = document.getElementById("business_information_dba_address");
  const dbaAddressCheckbox = document.getElementById(
    "business_information_dba_address_same_as_legal_address",
  );

  if (mailingAddressCheckbox) {
    mailingAddressCheckbox.addEventListener("click", function () {
      mailingAddressInput.value = mailingAddressCheckbox.checked ? legalAddressInput.value : "";
    });
  }

  if (dbaAddressCheckbox) {
    dbaAddressCheckbox.addEventListener("click", function () {
      dbaAddressInput.value = dbaAddressCheckbox.checked ? legalAddressInput.value : "";
    });
  }
};

const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      const legalAddressInput = document.getElementById("business_information_legal_address");
      if (legalAddressInput) {
        initializeFunctionality();
        break;
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

initializeFunctionality();
